<template>
  <button
    class="btn--pill pill"
    :class="{
      [`pill--${size}`]: !!size,
      [`pill--${thickness}`]: !!thickness,
      [color]: true,
      'btn--disabled': disabled,
      'btn--fill': fill
    }"
    :disabled="disabled"
    @click="onClick($event)"
  >
    <template v-if="!isLoading">
      <slot />
    </template>
    <template v-else>
      <span
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      />
      請稍候
    </template>
  </button>
</template>
<script>
import '~style/components/button.scss'
import '~style/components/pill.scss'
export default {
  name: 'ButtonWrapper',
  props: {
    color: {
      type: String,
      default: 'blue'
    },
    size: {
      type: String,
      default: ''
    },
    thickness: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fill: {
      type: Boolean,
      default: false
    },
    isLoading: Boolean
  },
  methods: {
    onClick (e) {
      if (!this.disabled) this.$emit('click', e)
    }
  }
}
</script>
